import { useMessage } from '..';
import { Message } from './Message';

export const MessagesContainer = () => {
  const { openedMessages } = useMessage();

  return (
    <div className="fixed right-[50%] top-[0px] z-[1000] flex w-full translate-x-[50%] px-4 flex-col items-center self-center pointer-events-none">
      {openedMessages?.map((message) => (
        <Message key={message.uuid} {...message} />
      ))}
    </div>
  );
};
